export const learningHubUrls = {
  slack: 'https://flair.hr/en/learning-hub/absences/#slackabsencerequests',
};
